function panelSection() {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      header: '@'
    },
    template:
      `<div ng-click="toggleExpanded()"
          class="panel-section--header"
          ng-class="{active : expanded}">
        <h6 translate>{{header}}</h6>
        <span>
          <i class="fa fa-{{icon}}"></i>
        </span>
      </div>
      <div ng-transclude ng-show="expanded" filter-set="filterSet"></div>`,
    controller: ['$scope', 'refineStateService', ($scope, refineStateService) => {
      // Get the state (expanded or !) of this search refiner
      $scope.expanded = refineStateService.isExpanded($scope.header);
      $scope.icon = $scope.expanded ? 'minus' : 'plus';

      $scope.$watch('expanded', refineStateService.curriedSet($scope.header));

      $scope.toggleExpanded = () => {
        $scope.expanded = !$scope.expanded;
        $scope.icon = $scope.expanded ? 'minus' : 'plus';
      };
    }]
  };
}

export default function (ngModule) {
  ngModule.directive('panelSection', panelSection);
}
